// Capa HTTP de los formatos de salida (FS01..FS07). Solo lectura: hoy son
// contexto para la futura generación con IA y se administran desde la planilla.
// El API envuelve todo en `data`.

import { apiFetch } from "./api";

export interface ResumenDeFormato {
  id: number;
  codigo: string;
  nombre: string;
  clientes: string | null;
  /** Cuántas plantillas admiten este formato. */
  plantillas_count: number;
}

export interface PlantillaCompatible {
  id: number;
  nombre: string;
  /** Este formato es el que se propone al elegir esa plantilla. */
  por_defecto: boolean;
}

export interface DetalleDeFormato {
  id: number;
  codigo: string;
  nombre: string;
  clientes: string | null;
  rasgos: string | null;
  items_propios: string[];
  orden_capitulos: string[];
  informes_analizados: number | null;
  plantillas: PlantillaCompatible[];
}

export async function fetchFormatos(): Promise<ResumenDeFormato[]> {
  const { data } = await apiFetch<{ data: ResumenDeFormato[] }>("/api/formatos-salida");
  return data;
}

export async function fetchFormato(id: number): Promise<DetalleDeFormato> {
  const { data } = await apiFetch<{ data: DetalleDeFormato }>(`/api/formatos-salida/${id}`);
  return data;
}
